export enum CanadianRegion {
  AB = 'CA-AB',
  BC = 'CA-BC',
  MB = 'CA-MB',
  NB = 'CA-NB',
  NL = 'CA-NL',
  NS = 'CA-NS',
  NT = 'CA-NT',
  NU = 'CA-NU',
  ON = 'CA-ON',
  PE = 'CA-PE',
  QC = 'CA-QC',
  SK = 'CA-SK',
  YT = 'CA-YT',
}
